// extracted by mini-css-extract-plugin
export default {"dialogContent":"WiQcjNGmBVYlQx81WxuH","scrollArea":"Ph4Zy9xDS2YjRBx50ElX"};